import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  q: '¿Sirve para mi país?',
  a: 'Sí. Funciona en México, Colombia, Argentina, Chile, Perú, Venezuela, España y todo el mundo hispanohablante.'
}, {
  q: '¿Cómo recibo el material?',
  a: 'PDF. Acceso inmediato por correo en menos de 5 minutos.'
}, {
  q: '¿Tengo que imprimir todo?',
  a: 'No. Funciona en pantalla o imprimes solo lo que necesitas cada semana.'
}, {
  q: '¿Sirve para todos los niveles?',
  a: 'Sí. Preescolar, Primaria y Secundaria. Variantes incluidas.'
}, {
  q: '¿Tiene garantía real?',
  a: '7 días. Escribes un correo y devolvemos el 100% sin preguntas.'
}];
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-white px-4 py-16" data-id="element-62">
      <div className="mx-auto max-w-2xl" data-id="element-63">
        <h2 className="mb-8 text-center font-display text-2xl font-black uppercase tracking-tight text-navy sm:text-3xl" data-id="element-64">
          ❓ Lo que más nos preguntan
        </h2>
        <div className="space-y-3" data-id="element-65">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <div key={f.q} className="overflow-hidden rounded-2xl border border-navy/10 bg-cream" data-id="element-66">
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-3 px-5 py-4 text-left" data-id="element-67">
                  <span className="font-display text-base font-bold text-navy" data-id="element-68">
                    {f.q}
                  </span>
                  <ChevronDownIcon className={`h-5 w-5 shrink-0 text-magenta transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} data-id="element-69" />
                </button>
                <AnimatePresence initial={false} data-id="element-70">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.25
              }} data-id="element-71">
                      <p className="px-5 pb-4 text-[15px] leading-relaxed text-navy/70" data-id="element-72">
                        {f.a}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}